<template>
  <div>
    <b-modal
        v-model="modalActive"
        hide-footer
        id="modal-center"
        centered
        :title="$t('message.Positions')">
      <b-form-group
          :label="$t('message.Name_uz')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="ranks.name_uz"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_ru')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="ranks.name_ru"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_en')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="ranks.name_en"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_kr')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="ranks.name_kz"
            required
        />
      </b-form-group>
      <label class="mt-2">{{$t('message.Position_level')}}</label>
      <b-form-select
          v-model="ranks.position_level_id"
          :options="position_level"
          text-field="name_uz"
          value-field="id"
          style="height: 40px"
          class="w-100"
      />
      <div
          style="margin-top: 30px; margin-left: 150px">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px" variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {addPosition, editPosition, getPositionById} from "../../../../../../api/directories";

export default {
  name: "RanksModal",
  props: {
    position_level:[],
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      ranks: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: '',
        position_level_id:''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchRanks(){
      getPositionById({ id : this.id }).then(response => {
        this.ranks = response.data.data
      })
    },
    handleSubmit() {
      if (this.ranks.name_uz
          && this.ranks.name_ru
          && this.ranks.name_en
          && this.ranks.name_kz
          && this.ranks.position_level_id) {
        const form = new FormData()
        form.append('id', this.ranks.id)
        form.append('name_uz', this.ranks.name_uz)
        form.append('name_ru', this.ranks.name_ru)
        form.append('name_en', this.ranks.name_en)
        form.append('name_kz', this.ranks.name_kz)
        form.append('level_id', this.ranks.position_level_id)
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editPosition(this.ranks).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addPosition(this.ranks).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchRanks()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
